module.exports = __webpack_public_path__ + "static/img/1-16.374d068.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-16.png
// module id = 58
// module chunks = 0